import { CONFIG_BASE_PATH } from '@/constants';
import { MaintenanceConfig, AppConfig } from '@/types/config';
import { apiRequest } from './client';

/**
 * Получение статуса maintenance режима
 */
export async function getMaintenanceStatus(): Promise<MaintenanceConfig> {
  return apiRequest<MaintenanceConfig>({
    url: `${CONFIG_BASE_PATH}/maintenance`,
    method: 'GET',
  });
}

/**
 * Получение всей конфигурации приложения
 */
export async function getConfig(): Promise<AppConfig> {
  return apiRequest<AppConfig>({
    url: CONFIG_BASE_PATH,
    method: 'GET',
  });
}

